import { render, staticRenderFns } from "./CFooter.vue?vue&type=template&id=40186f31&scoped=true&"
import script from "./CFooter.vue?vue&type=script&lang=js&"
export * from "./CFooter.vue?vue&type=script&lang=js&"
import style0 from "./CFooter.vue?vue&type=style&index=0&id=40186f31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40186f31",
  null
  
)

export default component.exports